import { render, staticRenderFns } from "./essays_table.vue?vue&type=template&id=6bcb1f5b&scoped=true&"
import script from "./essays_table.vue?vue&type=script&lang=js&"
export * from "./essays_table.vue?vue&type=script&lang=js&"
import style0 from "./essays_table.vue?vue&type=style&index=0&id=6bcb1f5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb1f5b",
  null
  
)

export default component.exports